<div *ngIf='userSessionData' class='AuthenticatedLayout d-flex flex-column' id='AuthenticatedLayout'>
  <div>
    <app-authenticated-header></app-authenticated-header>
  </div>
  <div class='AuthenticatedLayout-wrapper d-flex flex-row'>
    <app-left-menu></app-left-menu>
    <div class='AuthenticatedLayout-container' [class.expanded]="!leftMenuExpanded">
      <div class='AuthenticatedLayout-container-alerts container pt-3'>
        <div
          *ngIf='showAlert && alertMessage'
          class='alert alert-danger alert-dismissible fade show'
          role='alert'>
          {{ alertMessage }}
          <button
            aria-label='Close'
            class='btn-close'
            data-bs-dismiss='alert'
            type='button'></button>
        </div>
      </div>
      <div>
        <div class='flex-grow-1'>
          <div class='AuthenticatedLayout-container-page container-fluid' id='AuthenticatedLayoutContainer'>
            <div *ngIf='userSessionData && (userSessionData.campaigns_suspended || userSessionData.emails_suspended)'
                 class='alert alert-danger'>
              <p *ngIf='userSessionData.campaigns_suspended' class='m-0 text-center'>Your campaigns are suspended. To
                resume sending campaign messages, please
                contact
                administrator</p>
              <p *ngIf='userSessionData.emails_suspended' class='m-0 text-center'>Your emails are suspended. To resume
                sending emails, please contact administrator</p>
            </div>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-authenticated-footer></app-authenticated-footer>
</div>
